'use client';
import React, { useState, useEffect } from 'react';
import { notFound } from 'next/navigation';
import Homep from '@/app/componenets/Homep';
import Banner from '@/app/airports/[airportPage]/banner';
import SLider from '@/app/airports/[airportPage]/slider';
import Airport from '@/app/airports/[airportPage]/airport';
import MIa from '@/app/airports/[airportPage]/mia';
import Faq from '@/app/airports/[airportPage]/faq';
import MainData from '@/app/data/MainState';
import TawkTo from '../../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page({ params }) {
  const [image, setImage] = useState('');
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');

  const mapping = MainData?.find((p) => p?.link === params.airportPage);

  if (!mapping) {
    notFound(); // Ye Next.js ko 404 page dikhaane ke liye bolta hai
  }

  useEffect(() => {
    if (mapping) {
      const data = mapping?.data[0];
      setImage(data.image);
      setTitle(data.title);
      setSubtitle(data.subtitle);
    }
  }, [mapping]);

  return (
    <div>
      <title>
        {mapping?.data?.length > 0
          ? mapping.data[6].metaTitle
          : 'Prestige Ride | First-Class Black Car & Chauffeur Services'}
      </title>
      <meta
        name="description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />

      {/* OG Tags */}
      <meta
        property="og:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        property="og:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta
        property="twitter:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta
        name="twitter:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        name="twitter:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[6].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="robots" content="index, follow" />
      <meta
        name="keywords"
        content={mapping?.data?.length > 0 ? mapping.data[6].metaKeywords : ''}
      />
      <link
        rel="canonical"
        href={mapping?.data?.length > 0 ? mapping.data[6].Link : ''}
      />
      <TawkTo />
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />
      <Banner Mydata={mapping?.data} />
      <SLider Mydata={mapping?.data} />
      <Airport Mydata={mapping?.data} />
      <MIa Mydata={mapping?.data} />
      <Faq Mydata={mapping?.data} />
      <Footer />
    </div>
  );
}

export default page;
